export const QUESTION_TYPES = [
  {
    value: "text",
    label: "Short Text",
    hasOptions: false,
    canBeConditional: true,
    canTriggerConditional: false,
  },
  {
    value: "textarea",
    label: "Long Answer",
    hasOptions: false,
    canBeConditional: true,
    canTriggerConditional: false,
  },
  {
    value: "single_select",
    label: "Single Select",
    hasOptions: true,
    canBeConditional: true,
    canTriggerConditional: true,
    allowOther: true,
  },
  {
    value: "multi_select",
    label: "Multi Select",
    hasOptions: true,
    canBeConditional: true,
    canTriggerConditional: true,
    allowOther: true,
  },
  {
    value: "location",
    label: "Location Picker",
    hasOptions: false,
    canBeConditional: true,
    canTriggerConditional: false,
  },
  {
    value: "date",
    label: "Date Picker",
    hasOptions: false,
    canBeConditional: true,
    canTriggerConditional: false,
    allowOther: true,
  },
  {
    value: "photo_select",
    label: "Photo Selection",
    hasOptions: true,
    canBeConditional: true,
    canTriggerConditional: true,
  },
  {
    value: "likert_scale",
    label: "Likert Scale",
    hasOptions: false,
    canBeConditional: true,
    canTriggerConditional: false,
  },
  {
    value: "range",
    label: "Range Slider",
    hasOptions: false,
    canBeConditional: true,
    canTriggerConditional: false,
  },
];
